import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/tbill-calculator',
  component: () => import('../../routes/TBillCalculator.svelte'),
  card: {
    id: 'tbill-calculator',
    title: 'T-Bill Calculator',
    description: 'Calculate Treasury Bill returns and annualized yield. See what you earn when T-Bills mature.',
    icon: 'account_balance',
    iconBgClass: 'bg-blue-50',
    iconTextClass: 'text-blue-600',
    href: '/tbill-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'T-Bill Calculator – Treasury Bill Return & Yield Calculator',
    description: 'Free T-Bill calculator to calculate Treasury Bill returns and annualized yield. Enter purchase price, rate, and term to see what you earn at maturity.',
  },
};

export default meta;
